import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import { replaceObjectInList } from '../../../utility/helpers';
import PeopleInfoField from './peopleInfoField';
import { groupUserFieldsByCategories } from '../../pages/organizationSettingsPeopleInfoPage/config';

const useStyles = makeStyles(({ spacing }) => ({
  categoryTitle: {
    marginBottom: spacing(4),
    marginTop: spacing(6),
    '&:first-of-type': {
      marginTop: spacing(2),
    },
  },
}));

const PeopleInfoFields = ({
  values = [],
  translations,
  fieldTypes,
  onChange,
}) => {
  const classes = useStyles();

  const fieldIndexByName = useMemo(
    () =>
      values.reduce((acc, field, index) => {
        acc[field.name] = index;
        return acc;
      }, {}),
    [values]
  );

  const groupedCategories = useMemo(
    () => groupUserFieldsByCategories(values),
    [values]
  );

  const handleChangeValue = useCallback(
    (field, fieldIndex, linkedFieldUpdates) => {
      let updatedValues = replaceObjectInList(values, fieldIndex, field);

      if (linkedFieldUpdates) {
        Object.entries(linkedFieldUpdates).forEach(
          ([linkedFieldName, linkedFieldUpdate]) => {
            const linkedFieldIndex = fieldIndexByName[linkedFieldName];

            if (linkedFieldIndex !== undefined) {
              updatedValues = replaceObjectInList(
                updatedValues,
                linkedFieldIndex,
                {
                  ...updatedValues[linkedFieldIndex],
                  ...linkedFieldUpdate,
                }
              );
            }
          }
        );
      }

      onChange(updatedValues);
    },
    [values, onChange, fieldIndexByName]
  );

  const renderFields = fields =>
    fields.map(val => (
      <PeopleInfoField
        key={val.name}
        id={fieldIndexByName[val.name]}
        fieldTypes={fieldTypes}
        value={val}
        headersTranslations={translations.field.headers}
        onChange={handleChangeValue}
      />
    ));

  return (
    <div>
      {groupedCategories.map(category => (
        <div key={category.key}>
          <Typography className={classes.categoryTitle} variant="h5">
            {translations.categories[category.translationKey]}
          </Typography>
          {renderFields(category.fields)}
        </div>
      ))}
    </div>
  );
};

PeopleInfoFields.propTypes = {
  translations: PropTypes.object.isRequired,
  values: PropTypes.arrayOf(PropTypes.object),
  fieldTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PeopleInfoFields;
